import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  AdminComponent,
  HotelsComponent,
  LoadingSpinnerComponent,
  LoginComponent,
  StatisticsComponent,
} from './@Components';
import { componentsCommon } from './@Components/@common/components';
import { OnboardingDialog } from './@Dialogs/onboarding/onboarding.dialog';
import {
  AuthInterceptor,
  AuthService,
  DateService,
  EmailService,
  FocusService,
  HotelService,
  SnackbarService,
} from './@Services';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { registerLocaleData } from '@angular/common';
import localeHu from '@angular/common/locales/hu';
import { SearchComponent } from './@Components/search/search.component';
import { EmailDialog } from './@Dialogs';
import { SuccessfulSnackBar, UnsuccessfulSnackBar } from './@Snackbars';

registerLocaleData(localeHu);

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LoadingSpinnerComponent,
    AdminComponent,
    OnboardingDialog,
    EmailDialog,
    StatisticsComponent,
    HotelsComponent,
    SearchComponent,
    SuccessfulSnackBar,
    UnsuccessfulSnackBar,
    ...componentsCommon,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'hu-HU' },
    { provide: LOCALE_ID, useValue: 'hu-HU' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    AuthService,
    FocusService,
    DateService,
    HotelService,
    EmailService,
    SnackbarService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
